import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const ROWS_TO_JSON_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.ROWS_TO_JSON, 0> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['outputColumn', 'valueKey'],
  outputColumn: {
    displayName: 'Output column',
    infoText: 'Name of the JSON column to pack each row into. Defaults to "request".',
    configShapePath: ['outputColumn'],
  },
  valueKey: {
    displayName: 'Wrap value key',
    infoText:
      'Optional. Wraps each cell as {key: cell}. Use "value" to rebuild Benchling schema fields ({"value": x}).',
    configShapePath: ['valueKey'],
  },
};
